import React from 'react';

import styles from 'components/atoms/Button/Button.module.scss';
export const Button = ({ text, type, onClick }) => (
  <button onClick={onClick} type={type} className={styles.button}>
    {text}
  </button>
);
